<template>
    <div>
        <v-dialog v-model="abrir" persistent :width="width">
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="11">
                            <v-card-title class="titulopagina">Recepción de Aceite Bodegas Externas</v-card-title>
                        </v-col>
                        <v-col cols="1">
                            <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" @click="abrirAyudas" large>help</v-icon></v-alert>
                        </v-col>
                        <modal-ayuda></modal-ayuda>
                    </v-row> 
                </v-card-title>
                <v-progress-linear v-if="cargando" indeterminate color="blue darken-2"></v-progress-linear>
                <v-progress-linear v-if="error_load" indeterminate color="red darken-3"></v-progress-linear>
                <v-card-text>
                    <v-container>
                        <v-card elevation="8" class="pl-4">
                            <v-row>
                                <v-col cols="2">
                                    <h3 class="deep-purple--text">Fecha: {{despacho.fecha_hora_ticket | formatearFecha}}</h3>
                                </v-col>
                                <v-col cols="2">
                                    <h3 class="deep-purple--text">Destino: {{despacho.sucursal}}</h3>
                                </v-col>
                                <v-col cols="2">
                                    <h3 class="deep-purple--text">Patente: {{despacho.patente}}</h3>
                                </v-col>
                                <v-col cols="2">
                                    <h3 class="deep-purple--text">Ticket: {{despacho.codigo_ticket}}</h3>
                                </v-col>
                                <v-col cols="2">
                                    <h3 class="deep-purple--text">Guía: {{despacho.numero_guia}}</h3>
                                </v-col>
                                <v-col cols="2">
                                    <h3 class="deep-purple--text">Kilos R.: {{despacho.peso_real}}</h3>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-row v-for="(item,idx) in recepciones" :key="idx">

                            <v-col cols="1">
                                <v-text-field v-model="item.folio_destino" @change="set_folio_d($event)" label="Folio Destino"></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-select
                                :items="estanques_externos"
                                v-model="item.estanques_externos_id"
                                label="Estanque Abastecido"
                                item-text="nombre_corto"
                                item-value="id"
                                class=""
                                @change="set_tk($event)" 
                                ></v-select>
                            </v-col>
                            <v-col cols="2">
                                <p><label class="cyan lighten-4 mt-2" for="">Capacidad: </label>
                                <label class="cyan lighten-4 mt-2" for="" > {{item.capacidad | formatear_miles}} </label></p>
                                <p><label  class="cyan lighten-4 mt-2" for="">Stock: </label>
                                <label class="cyan lighten-4 mt-2" for="" > {{item.stock | formatear_miles}} </label></p>
                            </v-col>
                            <v-col cols="2">
                                <label for="">Fecha Abastecimiento</label>
                                <date-picker type="datetime" :clearable="false" :confirme="true" v-model="item.fecha_abastecimiento"  label="Fecha Abastecimiento"
                                format="DD-MM-YYYY HH:mm" :default-value="fecha_abastecimiento" @change="set_fecha($event)"  valueType="YYYY-MM-DD HH:mm"></date-picker>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field v-model="item.folio_abastecimiento" @change="set_folio_a($event)"  label="Folio Abastecimiento"></v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-select
                                :items="lotes_externos"
                                v-model="item.lotes_aceite_id"
                                label="Lote Final"
                                item-text="nombre_lote"
                                item-value="id"
                                class=""
                                @change="set_lote($event)" 
                                ></v-select>
                            </v-col>
                            <v-col cols="1">
                                <v-text-field v-model="item.litros" label="Litros"></v-text-field>
                            </v-col>
                            <v-col cols="1">
                                <v-btn color="orange darken-1" label=" + "> + </v-btn>
                                <v-btn color="red darken-4" dark small icon @click="eliminar_recepcion(item, idx)" 
                                 v-if="item.id" title="Eliminar Recepción">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-card-text>
                                <alert></alert>
                            </v-card-text>
                        </v-row>
                    </v-container>
                    <small>*Campos Obligatorios</small>
                </v-card-text>

                <modal-lotes-aceite></modal-lotes-aceite>
                <v-row>
                    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                </v-row>
                <v-card-actions>
                    <v-btn dark color="green light-darken-1" @click="abrir_modal_lote">Crear Lote Aceite</v-btn>
                    <v-spacer></v-spacer>

                    <v-btn color="blue darken-1" dark @click="abrir = false">Cerrar</v-btn>
                    <v-btn color="green darken-1" dark @click="submit" :disabled="!validar"> Guardar </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>
<script>
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Alert from '@/components/shared/Alert.vue';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
import Modal_Lotes_Aceite from '@/components/shared/Modal_Lotes_Aceite.vue';
import { mapState } from 'vuex';
export default {
    data:()=>({
        estanques_externos:[],
        lotes_externos:[],
        recepciones:[],
        fecha_abastecimiento:'',
        litros:0,
        despacho:{},
        bodega_actual:null,
        add_row:null,
        abrir:false,
        cargando:false,
        error_load:false,

        nro_lote:'',
    }),
    beforeDestroy() {
        Event.$off('abrir_modal_recepcion');
    },
    mounted(){
        this.$parent.$on('abrir_modal_recepcion',async (despacho)=>{
            console.log("despacho", despacho)
            this.despacho = despacho;
            this.bodega_actual = despacho.bodega_destino;
            this.abrir = true;
            await this.cargarEstanqes();
            await this.cargarRecepcion();
            await this.cargarLotes();
        })
        Event.$on('actualizar_lotes_ext',()=>{
            this.cargarLotes();
        });
    },
    methods:{
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de "Recepción de Aceite Bodegas Externas"`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se registra la recepción del aceite en bodegas. Los datos a registrar son: Folio destino, Estanque Destino, fecha recepción, Folio Abastecimiento y Lote final `},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async submit(){
            this.cargando = true;

            if (this.validar){
                //console.log('enviando peticion');
                let url = `${this.base_url}recepcion_despacho`;
                let data = {}
                let body = []

                if(this.recepciones.length > 0) {
                    this.recepciones.forEach((row) => {
                        data = {
                            despacho_aceite_prod_id:row.despacho_aceite_prod_id,
                            estanques_externos_id:  row.estanques_externos_id,
                            litros:                 row.litros,
                            fecha_abastecimiento:   row.fecha_abastecimiento,
                            folio_destino:          row.folio_destino,
                            folio_abastecimiento:   row.folio_abastecimiento,
                            lotes_aceite_id:        row.lotes_aceite_id,
                            //observacion:            row.observacion,
                            ticket:                 this.despacho.tickets_id
                        }
                        body.push(data)
                    })
                }

                await this.axios.post(url,body,this.headers).then((res)=>{
                    if(res.data.message != "Error"){
                        Event.$emit('actualizar_tabla');
                        this.abrir = false;
                    } else {
                        Event.$emit('mostrar_alert',{tipo: "success",mensaje: "Ticket " + despacho.tickets_id + " ya existe"});
                    }
                }).catch((error)=>{
                    console.log('error',error);
                    Event.$emit('mostrar_alert',{tipo: "error",mensaje: (error.message ? error.message : error)});
                })
            } else {
                console.log('nope');
            }
            this.cargando = false;
        },
        limpiar(){
            this.recepciones = [
                {   despacho_aceite_prod_id:    0,
                    estanques_externos_id:      null,
                    litros:                     this.despacho.peso_real,
                    fecha_abastecimiento:       this.moment().format('YYYY-MM-DD HH:mm'),
                    folio_destino:              '',
                    folio_abastecimiento:       '',
                    lotes_aceite_id:            null,
                    ticket:                     this.despacho.tickets_id,
                },
            ]
        },

        regexTest(string){
            let patt = new RegExp(/[^R\-0-9]+/g);
            let res = patt.test(string);
            return res;
        },

        async cargarEstanqes(){
            this.cargando = true;
            let url = `${this.base_url}estanques_externos?bodega=${this.bodega_actual}`;
            await this.axios.get(url,this.headers).then((response)=>{
                //console.log('Tipos estanques_externos',response);
                this.estanques_externos = response.data.data;
                this.error_load = false;
            }).catch((error)=>{
                console.log(error);
                this.error_load = true;
            });
            this.cargando = false;
        },

        async cargarLotes(){
            this.cargando = true;
            await this.axios.get(`${this.base_url}lotes_externos?estanque=${this.estanques_externos_id}`,this.headers).then((response)=>{
                this.lotes_externos = response.data.data;
                //console.log('lotes externos',response.data.data);
                this.error_load = false;
            }).catch((error)=>{
                console.log('error',error);
                this.error_load = true;
            });
            this.cargando = false;
        },

        async cargarRecepcion(){
            this.cargando = true;
            let url = `${this.base_url}despacho_aceite/buscar_recepcion`;
            let body = {
                ticket_id: this.despacho.tickets_id
            }
            this.limpiar()
            
            await this.axios.post(url,body,this.headers).then((res)=>{
                console.log('recepciones',res.data.data);
                if(res.data.data.length > 0) {
                    this.recepciones = res.data.data;
                }
                
                this.recepciones.map( row => {
                    row.folio_destino = res.data.folio ? res.data.folio : '' ;
                    row.capacidad = '';
                    row.stock = '';
                    if(row.estanques_externos_id){
                        let busca = this.estanques_externos.find(r =>{
                            return r.id == row.estanques_externos_id;
                        })
                        if (busca) {
                            row.capacidad = busca.capacidad
                            row.stock = busca.stock
                        }
                    }
                });
                console.log('recepciones v2',this.recepciones);

                this.error_load = false;
            }).catch((error)=>{
                console.log('error',error);
                this.error_load = true;
            });
            this.cargando = false;
            console.log("recepciones",this.recepciones)
        },
        set_folio_d(evento){
            this.recepciones.forEach( (row, idx) => {
                if (!row.folio_destino){
                    this.$set(this.recepciones[idx], "folio_destino", evento)
                }
            });
        },
        set_tk(evento){
            this.recepciones.forEach( (row, idx) => {
                if (!row.estanques_externos_id){
                    this.$set(this.recepciones[idx], "estanques_externos_id", evento)
                }

                let capacidad = '';
                let stock = '';
                if(evento){
                    let busca = this.estanques_externos.find(r =>{
                        return r.id == row.estanques_externos_id;
                    })
                    if (busca) {
                        capacidad = busca.capacidad
                        stock = busca.stock
                    }
                }
                console.log("evento", evento, "row.estanques_externos_id", row.estanques_externos_id, "capacidad", capacidad, "stock", stock)
                this.$set(this.recepciones[idx], "capacidad", capacidad)
                this.$set(this.recepciones[idx], "stock", stock)
            });
            //this.cargarLotes();
        },
        set_fecha(evento){
            this.recepciones.forEach( (row, idx) => {
                if (!row.fecha_abastecimiento){
                    this.$set(this.recepciones[idx], "fecha_abastecimiento", evento)
                }
            });
        },
        set_folio_a(evento){
            this.recepciones.forEach( (row, idx) => {
                if (!row.folio_abastecimiento){
                    this.$set(this.recepciones[idx], "folio_abastecimiento", evento)
                }
            });
        },
        set_lote(evento){
            this.recepciones.forEach( (row, idx) => {
                if (!row.lotes_aceite_id){
                    this.$set(this.recepciones[idx], "lotes_aceite_id", evento)
                }
            });
        },
        abrir_modal_lote(){
            let conf = {titulo:'Crear Nuevo Lote de Aceite Externo',tipo_peticion:'POST', item:this.despacho, bodega:this.bodega_actual};
            Event.$emit('modalcitah',conf);
            console.log("Hola event")
        },
        async eliminar_recepcion(item, idx){
            console.log(item);
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: `Desea eliminar recepción fecha ${item.fecha_abastecimiento} del listado ?`,
                okButton: 'Eliminar !!',
            })
            if(okei) {
                let le_id = {  id: item.id  }
                await this.axios.post(`${this.base_url}despacho_aceite/destroy_recepcion`,le_id,this.headers).then((res)=>{
                    this.recepciones.splice(idx,1);
                    console.log(res);
                }).catch((e)=>{
                    this.errorMessage(e, "Error al eliminar producción.");
                    console
                })
            }
            
        },
    },
    computed:{
        diferencia(){
            let diff = this.despacho.kilos_romana - this.litros
            return diff;
        },
        
        validar(){
            //console.log('this.litros', this.litros,'this.lote_aceite', this.lote_aceite, 'this.folio_abastecimiento',this.folio_abastecimiento , 'this.folio_destino',this.folio_destino)
            let suma = 0 
            let tk = true
            this.recepciones.forEach((row) => {
                suma += row.litros
                if (!row.estanques_externos_id){
                    tk = false
                }
            })
            if((suma == this.despacho.peso_real) && (tk)){
                return true;
            }else{
                return false;
            }
        },
        width () {
            switch (this.$vuetify.breakpoint.name) {
            case 'xs': return 320
            case 'sm': return 600
            case 'md': return 1000
            case 'lg': return 1400
            case 'xl': return 1800
            }
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        'alert':Alert,
        DatePicker,
        ConfirmDialogue,
        'modal-ayuda':ModalAyudas,
        'modal-lotes-aceite':Modal_Lotes_Aceite,
    }
}
</script>
<style>
.hidden{
    display: none;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined){
    background: #d2d6d8 !important;
    color: #212121 !important;
}
</style>